
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>首页</span></div>
    <div class="kj-home">
      <div class="kj-home-header">快捷入口</div>
      <div class="kj-home-content disFlex">
        <div class="kj-home-every " @click="toChange(1,'/UserList')">
          <div><img src="@/assets/images/com-user.png" /></div>
          <div class="kj-home-every-tit">学员中心</div>
        </div>
        <div class="kj-home-every" @click="toChange(3,'/BuyCurriculum')">
          <div><img src="@/assets/images/com-kc.png" /></div>
          <div class="kj-home-every-tit">课程中心</div>
        </div>
        <div class="kj-home-every" @click="toChange(5,'/Plan')">
          <div><img src="@/assets/images/cpm-pl.png" /></div>
          <div class="kj-home-every-tit">学习计划</div>
        </div>
        <div class="kj-home-every" @click="toChange(6,'/OrderTask')">
          <div><img src="@/assets/images/com-order.png" /></div>
          <div class="kj-home-every-tit">订单中心</div>
        </div>
        <div class="kj-home-every" @click="toChange(7,'/CompanyInfo')">
          <div><img src="@/assets/images/com-info.png" /></div>
          <div class="kj-home-every-tit">企业中心</div>
        </div>
      </div>
    </div>

    <div class="disFlex kj-home-tj">
      <div class="kj-home-tj-every">
        <div class="kj-home-tj-header">员工统计</div>
        <div class="disFlex">
          <div class="flex1">
            <div><span class="kj-home-tj-num">{{tjData.monthemployeenum?tjData.monthemployeenum:0}}</span>人</div>
            <div class="kj-home-tj-name">本月新增学员</div>
          </div>
          <div class="flex1">
            <div><span class="kj-home-tj-num">{{tjData.allemployeenum?tjData.allemployeenum:0}}</span>人</div>
            <div class="kj-home-tj-name">总学员</div>
          </div>
        </div>
      </div>
      <div class="kj-home-tj-every">
        <div class="kj-home-tj-header">课程统计</div>
        <div class="disFlex">
          <div class="flex1">
            <div><span class="kj-home-tj-num">{{tjData.ygdescriptivtj?tjData.ygdescriptivtj:0}}</span>个</div>
            <div class="kj-home-tj-name">已购课程</div>
          </div>
          <div class="flex1">
            <div><span class="kj-home-tj-num">{{tjData.owndescriptivtj?tjData.owndescriptivtj:0}}</span>个</div>
            <div class="kj-home-tj-name">自研课程</div>
          </div>
        </div>
      </div>
      <div class="kj-home-tj-every">
        <div class="kj-home-tj-header">学习计划统计</div>
        <div class="disFlex">
          <div class="flex1">
            <div><span class="kj-home-tj-num">{{tjData.monthplannum?tjData.monthplannum:0}}</span>项</div>
            <div class="kj-home-tj-name">本月新增计划</div>
          </div>
          <div class="flex1">
            <div><span class="kj-home-tj-num">{{tjData.allplannum?tjData.allplannum:0}}</span>项</div>
            <div class="kj-home-tj-name">历史计划</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ComHome',
    data() {
      return {
        tjData:{}
      }
    },
    methods: {
      toChange: function(dhFlag, path) {
        this.$emit('changeCom',dhFlag, '/Company'+path);
      },
      getTjdata:function(){
        this.$axios.get('/kt/learnfile/getaddemployee.htm').then(res => {
          var data = res.data;
          if(data.stat=='1'){
            this.tjData=data.data;
          }else{
            this.$message.error(data.message);
          }
        })
      },
    },
    components: {},
    created: function() {
      this.getTjdata();
    },
    watch: {}
  }
</script>

<style>
  .kj-home {
    margin-top: 20px;
    border-radius: 4px;
  }

  .kj-home-header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #efefef;
    background-color: #fff;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    padding-left: 20px;
  }

  .kj-home-content {
    background-color: #fff;
    padding: 35px;
  }

  .kj-home-every {
    cursor: pointer;
    text-align: center;
    width: 200px;
  }

  .kj-home-every-tit {
    margin: 20px 0 0;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #333333;
  }

  .kj-home-tj {
    margin-top: 20px;
  }

  .kj-home-tj-every {
    width: 305px;
    height: 176px;
    background: #ffffff;
    border-radius: 4px;
    text-align: center;
    margin: 0 30px 0 0;
  }

  .kj-home-tj-every .flex1:first-child {
    position: relative;
  }

  .kj-home-tj-every .flex1:first-child::after {
    position: absolute;
    content: ' ';
    display: block;
    width: 1px;
    height: 30px;
    opacity: 1;
    background-color: #efefef;
    right: 0;
    top: 15px;
  }

  .kj-home-tj-header {
    height: 59px;
    line-height: 59px;
    border-bottom: 1px solid #efefef;
    text-align: left;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    padding-left: 20px;
    margin-bottom: 27px;
  }

  .kj-home-tj-num {
    opacity: 1;
    font-size: 30px;
    font-family: 'HelveticaNeue';
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    line-height: 38px;
  }

  .kj-home-tj-name {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
  }
</style>



// WEBPACK FOOTER //
// src/components/company/ComHome.vue